<script lang="ts" setup>
import SxMain from '~/components/sx/SxMain.vue';
</script>

<template>
  <div class="sx-landing">
    <sx-main />
  </div>
</template>

<style scoped lang="scss">
.sx-landing {
  color: #000000;
  font-family: AlsHauss, sans-serif;
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 100vh;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
